/**
 * @fileoverview DELETE handler for the "/apps/:app_group_id/products_settings" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdProductsSettingsCacheKeys } from "./constants";
import type {
  DeleteAppsAppGroupIdProductsSettingsProps,
  DeleteAppsAppGroupIdProductsSettingsResult,
} from "./types";

export const deleteAppsAppGroupIdProductsSettings = reactQueryMutationAdapter(
  appsAppGroupIdProductsSettingsCacheKeys,
  (props: DeleteAppsAppGroupIdProductsSettingsProps): Promise<DeleteAppsAppGroupIdProductsSettingsResult> => {
    return fetch(
      `/apps/${props.appGroupId}/products_settings`,
      "DELETE",
      props,
      {},
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
